import { convertDateToStructured } from "./CIITools";
import { ICurrencyCode } from "../graphql";
export class DecoderVoid {
    getVersion() {
        return { versionText: "Unbekannt", isDeprecated: false, version: "" };
    }
    getInvoiceID() {
        return undefined;
    }
    getInvoiceDate() {
        return convertDateToStructured(undefined);
    }
    getCurrency() {
        return ICurrencyCode.Eur;
    }
    getDeliveryDate() {
        return undefined;
    }
    getPaymentReference() {
        return undefined;
    }
    getGeneralPaymentDetails() {
        return { dueDate: undefined, description: undefined };
    }
    getSupplierPaymentType() {
        return { type: undefined, IBAN: undefined, BIC: undefined, accountName: undefined };
    }
    getTaxes() {
        return [];
    }
    getSupplier() {
        return { name: undefined, vatId: undefined, taxId: undefined, addressLines: [], communications: [] };
    }
    getBuyer() {
        return { name: undefined, vatId: undefined, taxId: undefined, addressLines: [], email: undefined };
    }
    getLineItems() {
        return [];
    }
}
//# sourceMappingURL=DecoderVoid.js.map